import {Place, SeatingPlan} from '@wix/ambassador-seating-public/types'
import {getFormattedMoney, WIX_EVENTS_TICKET_DEFINITION_FQDN} from '@wix/wix-events-commons-statics'
import {TFunction} from 'react-i18next'
import {SelectedSeat} from '../types/seating'
import {getFee, getTax} from './tax-and-fee'

interface GetSeatWithTicketInfoArgs {
  plan: SeatingPlan
  tickets: wix.events.ticketing.TicketDefinition[]
  event: wix.events.Event
  seat: Place
  categoryId: number
  t: TFunction
}

export const getSeatWithTicketInfo = ({
  plan,
  tickets,
  event,
  seat,
  categoryId,
  t,
}: GetSeatWithTicketInfoArgs): SelectedSeat => {
  const {
    externalId,
    config: {color},
  } = plan.categories.find(category => category.id === categoryId)
  const ticketDefinition = getTicketDefinitionByExternalId(tickets, externalId)
  const [sectorId, rowId] = seat.id.split('-')
  const sector = plan.sectors.find(item => item.id === Number(sectorId))
  const row = sector.elements.find(item => item.id === Number(rowId))

  return {
    id: seat.id,
    sector: sector.title,
    seat: seat.label,
    row: row.title,
    ticketPrice: getFormattedMoney(ticketDefinition.price),
    fees: [getTax(event, ticketDefinition, t), getFee(event, ticketDefinition, t)].filter(Boolean).join(', '),
    ticketName: ticketDefinition.name,
    ticketId: ticketDefinition.id,
    color,
  }
}

export const getTicketDefinitionByExternalId = (tickets: wix.events.ticketing.TicketDefinition[], externalId: string) =>
  tickets.find(ticketDef => ticketDef.id === externalId.replace(WIX_EVENTS_TICKET_DEFINITION_FQDN, ''))
